// extracted by mini-css-extract-plugin
export default {"container":"SummaryDrawer_container__4Lmwy","preview":"SummaryDrawer_preview__QADNv"};